import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { KpiDefinition } from '@tran-monorepo/interfaces/applications';
import { Observable } from 'rxjs';

export const KPIS_API_URL = new InjectionToken<string>('KPIS_API_URL');

@Injectable({ providedIn: 'root' })
export class KpisService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(KPIS_API_URL);

    public getKpis(): Observable<KpiDefinition[]> {
        return this.http.get<KpiDefinition[]>(this.apiUrl);
    }
}
